import React, { useState } from "react";
import styles from "../../customDashboard.module.css";
import Button from "../../../../../components/button/button";
import DashboardIcon from "../../../../../assets/icons/dashboard-icon.svg";

const EmptyState = ({ onStartCreating }) => {
  const [showHowItWorksModal, setShowHowItWorksModal] = useState(false);

  return (
    <>
      <div className={styles.emptyStateContainer}>
        {/* Hero Card Central */}
        <div className={styles.emptyStateHero}>
          <div className={styles.emptyStateHeroContent}>
            <h1 className={styles.emptyStateTitle}>
              Você ainda não tem dashboards customizados
            </h1>
            <p className={styles.emptyStateSubtitle}>
              Crie visões personalizadas com os indicadores financeiros e acadêmicos 
              da sua instituição em um só lugar.
            </p>
            <div className={styles.emptyStateActions}>
              <Button
                text="Criar meu primeiro dashboard"
                size="normal"
                variation="primary"
                onClick={onStartCreating}
              />
              <button 
                className={styles.emptyStateSecondaryLink}
                onClick={() => setShowHowItWorksModal(true)}
              >
                Entenda como funciona
              </button>
            </div>
          </div>
          <div className={styles.emptyStateIllustration}>
            <img src={DashboardIcon} alt="Dashboard" />
          </div>
        </div>

        {/* Como Funciona - 3 Passos */}
        <div className={styles.howItWorksSection}>
          <h3 className={styles.howItWorksTitle}>Como funciona</h3>
          <div className={styles.stepsGrid}>
            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>1</div>
              <h4 className={styles.stepTitle}>Escolha os indicadores</h4>
              <p className={styles.stepDescription}>
                Selecione os indicadores disponíveis no catálogo e defina a ordem deles na tela.
              </p>
            </div>
            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>2</div>
              <h4 className={styles.stepTitle}>Defina os filtros globais</h4>
              <p className={styles.stepDescription}>
                Escolha o período e outros filtros que serão aplicados para todos os indicadores do dashboard.
              </p>
            </div>
            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>3</div>
              <h4 className={styles.stepTitle}>Salve e compartilhe</h4>
              <p className={styles.stepDescription}>
                Dê um nome, defina a visibilidade (somente você ou toda a instituição) e pronto.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Modal "Como Funciona" */}
      {showHowItWorksModal && (
        <div className={styles.modalOverlay} onClick={() => setShowHowItWorksModal(false)}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h2 className={styles.modalTitle}>Como criar um dashboard customizado</h2>
              <button className={styles.modalClose} onClick={() => setShowHowItWorksModal(false)}>
                ×
              </button>
            </div>
            <div className={styles.modalBody}>
              <div className={styles.tutorialStep}>
                <div className={styles.tutorialStepNumber}>1</div>
                <div className={styles.tutorialStepContent}>
                  <h4>Escolha os indicadores</h4>
                  <p>
                    Na barra lateral direita, você encontrará todos os indicadores disponíveis 
                    organizados por categoria (Financeiro e Educacional). Basta arrastar o 
                    indicador desejado para uma das caixas na área principal.
                  </p>
                </div>
              </div>
              <div className={styles.tutorialStep}>
                <div className={styles.tutorialStepNumber}>2</div>
                <div className={styles.tutorialStepContent}>
                  <h4>Configure os filtros</h4>
                  <p>
                    Use os filtros no topo da tela para definir o período de análise, tipo de curso, 
                    área de conhecimento, localidade e modalidade. Esses filtros serão aplicados a 
                    todos os indicadores do seu dashboard.
                  </p>
                </div>
              </div>
              <div className={styles.tutorialStep}>
                <div className={styles.tutorialStepNumber}>3</div>
                <div className={styles.tutorialStepContent}>
                  <h4>Organize o layout</h4>
                  <p>
                    Você pode redimensionar cada indicador arrastando o canto inferior direito. 
                    Para reordenar, arraste pela área superior do indicador e solte na posição desejada.
                  </p>
                </div>
              </div>
              <div className={styles.tutorialStep}>
                <div className={styles.tutorialStepNumber}>4</div>
                <div className={styles.tutorialStepContent}>
                  <h4>Salve seu dashboard</h4>
                  <p>
                    Quando estiver satisfeito com o layout, clique em "Criar Dashboard", 
                    dê um nome e descrição. Seu dashboard ficará salvo e você poderá acessá-lo 
                    sempre que quiser.
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.modalFooter}>
              <Button
                text="Entendi, vamos começar!"
                size="normal"
                variation="primary"
                onClick={() => {
                  setShowHowItWorksModal(false);
                  onStartCreating();
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EmptyState;

